var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 47.9375H55.3125V51.625H3.6875V47.9375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8312 16.5938C48.3062 15.1187 48.3062 12.9062 46.8312 11.4312L40.1937 4.79375C38.7187 3.31875 36.5063 3.31875 35.0312 4.79375L7.375 32.45V44.25H19.175L46.8312 16.5938ZM37.6125 7.375L44.25 14.0125L38.7188 19.5438L32.0812 12.9062L37.6125 7.375ZM11.0625 40.5625V33.925L29.5 15.4875L36.1375 22.125L17.7 40.5625H11.0625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4b1229a63ec5e299766728d5e779aa51.svg";
export { ForwardRef as ReactComponent };